import {useState} from 'react';
import {styled} from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputBase from '@mui/material/InputBase';
import Backdrop from '@mui/material/Backdrop';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import styles from '../../../assets/jss/LogBook/LogBookStyles';
import {makeStyles} from '@mui/styles';
import {digitsEnToFa} from 'persian-tools2';
import {usePatientInfo} from 'hooks/usePatient';

const useStyles = makeStyles(styles);
const BootstrapInput = styled(InputBase)(({theme}) => ({
  'label + &': {
    // marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    zIndex: '2',
    background: '#F4F4F4',
    border: '1px solid #FFFFFF',
    marginRight: '50px',
    borderRadius: '98px',
    width: '240px',
    margin: '0 auto 0',
    boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)',

    fontFamily: 'dana-bold',
    fontSize: '10px',
    textAlign: 'center',
    color: '#707070',
    '&:focus': {
      background: '#F4F4F4',
      border: '1px solid #FFFFFF',
      marginRight: '50px',
      borderRadius: '98px',
      // width: '240px',
      margin: '0rem auto',
      boxShadow: '-2px -2px 4px #FFFFFF, 4px 4px 10px rgba(0, 0, 0, 0.1)',
    },
  },
}));

export default function FilterComponent(props) {
  const {patientId} = props;
  const [filterChoice, setFilterChoice] = useState('3');
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const {data: patientInfo} = usePatientInfo(patientId);
  const {isPregnant} = patientInfo || {};

  const range = isPregnant
    ? ['120', '120 - 60', '60']
    : ['180', '180 - 70', '70'];
  const labels = [
    {
      label: `نمایش تست‌های در محدوده هدف ( ${digitsEnToFa(range[1])} )`,
      color: 'rgba(59, 186, 76, 1)',
      class: classes.inRangeSelected,
    },
    {
      label: `نمایش  تست های بالا  ( > ${digitsEnToFa(range[0])} )`,
      color: 'rgba(254, 177, 64, 1)',
      class: classes.highSelected,
    },

    {
      label: `نمایش تست‌های پایین ( < ${digitsEnToFa(range[2])} )`,
      color: 'rgba(216, 29, 93, 1)',
      class: classes.lowSelected,
    },
  ];

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const handleChange = (event) => {
    props.filterChoice(event.target.value);
    setFilterChoice(event.target.value);
  };
  const MyIcon = (props) => {
    const {style, ...otherProps} = props;
    const colorStyle = {
      color: '#707070',
      zIndex: '3',
      marginRight: '8px',
    };
    const styles = {...style, ...colorStyle};
    return <ExpandMoreIcon {...otherProps} style={styles} />;
  };
  return (
    <>
      <Backdrop
        sx={{
          color: '#fff',
          //because navigation zIndex is 100
          zIndex: '101',
          background: 'rgba(216, 216, 216, 0.37);',
        }}
        open={open}
        onClick={handleClose}
      />
      <FormControl sx={{m: 1}} variant='standard'>
        <Select
          onOpen={handleToggle}
          onClose={handleToggle}
          id='demo-customized-select-native'
          value={filterChoice}
          IconComponent={MyIcon}
          classes={{
            select: `${classes.selectStyle} ${
              filterChoice === 0 && classes.inRange
            }
                        ${filterChoice === 1 && classes.high} ${
              filterChoice === 2 && classes.low
            }`,
            iconOpen: classes.iconOpen,
          }}
          onChange={handleChange}
          input={<BootstrapInput />}
          MenuProps={{
            style: {marginLeft: '5px', marginTop: '10px'},
            classes: {paper: classes.select},
          }}>
          <MenuItem value={3} classes={{selected: classes.allSelected}}>
            نمایش همه تست ها{' '}
          </MenuItem>
          {labels.map((item, index) => (
            <MenuItem
              value={index}
              classes={{selected: item.class}}
              style={{color: item.color}}>
              <FiberManualRecordIcon
                sx={{fontSize: '8px', padding: '0 0 0 5px', color: item.color}}
              />
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
